/* eslint-disable react/prop-types */
import {
  PageTitle,
  BottomButtons,
  BPReviewPanel,
  ReviewItemList, RAReviewPanel,
} from '@components';

import { Checkbox } from '@mui/material';
import { ClaimType, regEmail } from '@constants';
import { EmailForm } from './EmailForm';
import classes from './index.module.css';
import { useReview } from './hooks';

const TITLE = 'Please review and finish';
const CONFIRM_TEXT = 'I certify that any information I submit is truthful and accurate';
const EMAIL_TITLE = 'Please leave a frequently used email  to receive updates of your claim from us';

const ConfirmCheck = ({ checked, onChange }) => (
  <section className={classes.confirm_check}>
    <Checkbox
      checked={checked}
      onChange={onChange}
      color="input"
      style={{ padding: '0px' }}
    />
    <section className={classes.confirm_text}>{CONFIRM_TEXT}</section>
  </section>
);

export const Review = () => {
  const {
    files,
    email,
    type,
    orderName,
    selectedPackageList,
    isConfirmed,
    reviewData,
    isLoading,
    reasonList,
    comments,
    customEmail,
    onClickContinue,
    handleChange,
    handleEmailChange,
  } = useReview();
  const validEmail = regEmail.test(email) ? email : undefined;

  return (
    <section className={classes.content}>
      <PageTitle title={TITLE} />
      {type === ClaimType.RA
        ? <RAReviewPanel reviewInfo={reviewData} />
        : <BPReviewPanel reviewInfo={reviewData} />}
      <ReviewItemList
        selectedPackageList={selectedPackageList}
        orderName={orderName}
        files={files}
        comments={comments}
        type={type}
        reasonList={reasonList}
      />
      { !validEmail && <EmailForm onChange={handleEmailChange} title={EMAIL_TITLE} />}

      <ConfirmCheck checked={isConfirmed} onChange={handleChange} />
      <BottomButtons
        isContinueLoading={isLoading}
        isContinueDisabled={!(isConfirmed && customEmail)}
        continueText="Submit"
        showContinueIcon={false}
        onClickContinue={onClickContinue}
      />
    </section>
  );
};
